import { Button, Stack, TextField } from '@mui/material';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import { useMemo } from 'react';
import * as yup from 'yup';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { INTERVIEW_STATUS } from '../utils/interviewStatusJson';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { patchPlacementTracker } from '../../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';

export default function PlacementTrackerPatchComponent({ type, setRefresh, row, setModalState }) {
  const initialValues = useMemo(
    () => ({
      placement_tracker_id: row?.placement_tracker_id,
      ...(type
        ? {
            final_interview_status: row?.final_interview_status ?? '',
            final_interview_comments: row?.final_interview_comments ?? '',
            email: '',
          }
        : {
            first_interview_status: row?.first_interview_status ?? '',
            first_interview_comments: row?.first_interview_comments ?? '',
          }),
    }),
    [type, row],
  );

  const validationSchema = useMemo(
    () =>
      type
        ? yup.object({
            final_interview_status: yup.string().required('status is required'),
            email: yup.string().email('give valid email').required('email is required'),
          })
        : yup.object({
            first_interview_status: yup.string().required('status is required'),
          }),
    [type],
  );

  const submitLoading = useSelector((state) => state.general.submitLoading);
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      dispatch(patchPlacementTracker(values)).then((res) =>
        apiHelper(res, {
          onSuccess: () => {
            setRefresh((prev) => !prev);
            setModalState(false);
          },
        }),
      );
    },
  });
  return (
    <FormikProvider value={formik}>
      <Form>
        <Stack gap={2}>
          <GlobalSelectField
            options={{
              label: type ? 'Final Interview Status' : 'First Interview Status',
              formik,
              name: type ? 'final_interview_status' : 'first_interview_status',
              keys: {
                id: 'id',
                value: 'value',
              },
              data: INTERVIEW_STATUS,
              setFieldName: 'value',
            }}
          />
          {Boolean(type) && (
            <Field
              as={TextField}
              name={'email'}
              label={'Email'}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          )}
          <Field
            as={TextField}
            multiline
            minRows={3}
            label={type ? 'Final Interview Comment' : 'First Interview Comment'}
            name={type ? 'final_interview_comments' : 'first_interview_comments'}
          />
          <Button variant="contained" sx={{ alignSelf: 'flex-end' }} type="submit" disabled={submitLoading}>
            {submitLoading ? 'Submitting...' : 'Submit'}
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
